import { useCallback } from 'react';
import DatabaseService from 'shared/db/services/Database.web';

import { useDBSyncContext } from '@/context/DBSyncContext';
import { synchronizeDB } from '@/services/database/dbSync';

export const useSyncDB = () => {
    const { setIsSyncInProgress, setHasSyncIssue } = useDBSyncContext();

    const syncDB = useCallback(async () => {
        await synchronizeDB(DatabaseService.getDatabase(), {
            setIsInProgress: setIsSyncInProgress,
            setIsLastSyncFailed: setHasSyncIssue,
        });
    }, [setIsSyncInProgress, setHasSyncIssue]);

    return { syncDB };
};
